//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { deserializeMediaItems } from '@apis/media-library/mediaLibraryApiUtils';
import { isScheduledOrganicPinConfig } from '@apis/universal-posts/config/universalScheduledPostsConfigUtils';
import { deserializeConnectionArray } from '@apis/universal-posts/connections/universalPostConnectionUtils';
import {
  IScheduledPin,
  IScheduledPost,
} from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import { mapPostConfigToPostType } from '@apis/universal-posts/universalPostsUtils';
import PostableStatus from '@models/PostableStatus';
import { Serialized } from '@utils/types/Serialized';

export const deserializeScheduledPost = (
  scheduledPost: Serialized<IScheduledPost>,
): IScheduledPost => ({
  ...scheduledPost,
  postType: mapPostConfigToPostType(scheduledPost.config['@type']),
  scheduledTime: new Date(scheduledPost.scheduledTime),
  status: PostableStatus[scheduledPost.status],
  mediaItems: deserializeMediaItems(scheduledPost.mediaItems),
  connections: deserializeConnectionArray(scheduledPost.connections),
});

export const isScheduledPin = (post: IScheduledPost): post is IScheduledPin => {
  return isScheduledOrganicPinConfig(post.config);
};
